<div class="privacy-text">
	<p class="privacy-text__item">
		{{ 'PRIVACY_POLICY.INTRO.' + mode + '.PLATFORM_DESC' | translate }}
	</p>
	@if (mode === 'WEB') {
	<p class="privacy-text__item">
		{{ 'PRIVACY_POLICY.INTRO.WEB.PROCESSING_NOTICE' | translate }}
	</p>
	}
</div>